<template>
  <div class="picmanger">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>系统设置</el-breadcrumb-item>
          <el-breadcrumb-item>推送渠道管理</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div class="main">
      <div class="head">
        <h4>推送渠道管理</h4>
        <p @click="openDialog" :style="{'border':'none','color': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">+新增渠道</p>
      </div>

      <div class="tablebg"
           v-loading="isRefresh">
        <div style="width:100%;margin:0 auto;">
          <pushchanneltable :tableData="pushChannelList"
                            @seeClick="seeClick"
                            @changeClick="changeClick"
                            @closeClick="closeClick"
                            @removeClick="removeClick"
                            @openPzClick="openPzClick"></pushchanneltable>
        </div>

        <div class="pagination">
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page.sync="currentPage"
                         :page-size="pageSize"
                         layout="prev, pager, next"
                         :total="total">
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog :title="title"
               width="28%"
               :before-close="handleClose"
               :visible.sync="mydialogVisible">
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>{{title}}</div>
      </div>
      <el-form :model="myform"
               ref="myform"
               label-width="100px"
               :rules="rules">
        <el-form-item v-if="isSee"
                      label="渠道名称："
                      prop="name">
          <el-input v-model="myform.name"
                    placeholder="必填，2-10个字"></el-input>
        </el-form-item>
        <el-form-item v-if="isSee"
                      label="模板："
                      prop="template">
          <el-select v-model="myform.template"
                     placeholder="请选择模板">
            <el-option v-for="(e,i) in template"
                      :key="i"
                      :label="e.template"
                      v-html="'<span style=color:#303030;>'+ e.template +'</span>'"
                       :value="e.templateName"></el-option>
            <!-- <el-option label="路特全媒体渠道"
                      v-html="'<span style=color:#303030;>路特全媒体渠道</span>'"
                       value="routersoft-qms"></el-option>
            <el-option label="路特融媒体渠道"
                      v-html="'<span style=color:#303030;>路特融媒体渠道</span>'"
                       value="routersoft-mcp"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item>
          <div slot="label"
               class="labelclass">
            配置：
            <p @click="isSee && shili()">
              (
              <span style="color:#185ED3;cursor: pointer;">示例</span>)
            </p>
          </div>
          <el-input type="textarea"
                    :disabled="isSee ? false : true"
                    :autosize="{ minRows: 7}"
                    v-model="myform.config"></el-input>
        </el-form-item>
      </el-form>
      <div v-if="isSee"
           slot="footer"
           class="dialog-footer">
        <el-button @click="quit">取 消</el-button>
        <el-button type="primary"
                   v-if="!isClick"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="submit('myform')">提 交</el-button>
        <el-button type="primary"
                   v-else
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   disabled>提 交</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="shilidialogVisible"
               width="30%">
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>示例</div>
      </div>
      <div>
        <!-- {
        <div v-for="(value,key,index) in demo" :key="index">
          <div v-if="key !== 'tags'">
            <span>{{key}} : </span>
            <span>{{value}}</span>
          </div>
          <div v-if="key === 'tags'">
            <span>{{key}} : </span>
            <span v-for="(e,i) in value" :key="i">{{e}} </span>
          </div>
        </div>
        } -->
        {{demo}}
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="shilidialogVisible = false">取 消</el-button>
        <el-button type="primary"
                  :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="shilidialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { pushchanneltable } from "@/components/index";
import { formatConversion } from "@/plugins/getdate";
import { mapGetters } from "vuex";
import {
  listPushChannel,
  updatePushChannel,
  addPushChannel,
  getPushChannel,
  deletePushChannel,
  getPowerTemplate
} from "@/api/pushChannel";
export default {
  components: {
    pushchanneltable: pushchanneltable
  },
  computed: {
    ...mapGetters(["createUid"]),
  },
  data () {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 10,
      title: '',
      isSee: true,
      total: 0,
      currentPage: 1,
      mydialogVisible: false,
      shilidialogVisible: false,
      pushChannelList: [],
      template:[],
      demo: {},
      myform: {
        name: "",
        template: "",
        config: "",
        status: '0',
        createUid: this.createUid
      },
      rules: {
        name: [
          { required: true, message: "请输入渠道名称", trigger: "blur" },
          { min: 2, max: 10, message: "长度在 2 到 10 个字符", trigger: "blur" }
        ],
        template: [{ required: true, message: "请选择模板", trigger: "change" }],
        config: [{ required: true, message: "请输入配置", trigger: "blur" }]
      },
      timeInt: '',
      isRefresh: false
    };
  },
  methods: {


    //分页事件
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      this.currentPage = val
      let data = { page: (this.currentPage - 1), pageSize: this.pageSize }
      // console.log(data)
      this.listPushChannelAsync(data)
    },


    //刷新表格
    refresh () {

      this.isRefresh = true
      this.handleCurrentChange(this.currentPage);
      setTimeout(() => {
        this.isRefresh = false
      }, 888);
    },





    shili () {
      this.getPowerTemplateAsync()
      if (this.myform.config) {
        this.shilidialogVisible = true
      } else {
        this.$refs['myform'].validate(valid => {
          if (valid) {
            setTimeout(() => {
              this.myform.config = JSON.stringify(this.demo)
              // for (const key in this.demo) {
              //   if (this.demo.hasOwnProperty(key)) {
              //     this.myform.config += key + ':' + this.demo[key] + ' ; '
              //   }
              // }
            }, 666);
          } else {
            // console.log("error submit!!");
            return false;
          }
        });
      }

    },













    clearData () {
      this.myform = {
        name: "",
        template: "",
        config: "",
        status: '0',
        createUid: this.createUid
      };
      if (this.$refs['myform']) {
        this.$refs['myform'].clearValidate();
      }
    },
    openDialog () {
      this.title = '新增推送渠道'
      this.isSee = true
      this.mydialogVisible = true;
      // this.$refs['myform'].clearValidate();
      this.clearData()
      this.myform.template = 'routersoft-qms'
    },
    quit () {
      this.mydialogVisible = false;
      this.clearData()
    },
    handleClose () {
      this.mydialogVisible = false;
      this.clearData()
    },
    submit (form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.isClick = true
          setTimeout(() => {
            this.isClick = false
          }, 2000);
          // this.myform.config = this.demo
          if (this.myform.id) {
            this.updatePushChannelAsync(this.myform)
          } else {
            this.addPushChannelAsync(this.myform)
          }
          setTimeout(() => {
            this.clearData()
          }, 1000);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },



    //修改渠道
    changeClick (data) {
      this.title = '修改推送渠道'
      this.isSee = true
      this.getPushChannelAsync(data.row.id, 0)
    },

    //查看渠道配置
    seeClick (data) {
      this.title = '查看推送渠道'
      this.isSee = false
      this.getPushChannelAsync(data.row.id, 0)
    },

    //改变渠道状态
    closeClick (data) {
      this.$confirm("确认修改状态吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          this.getPushChannelAsync(data.row.id, 1)
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消"
          // });
        });
    },

    //删除渠道
    removeClick (data) {
      this.$confirm("确定删除渠道吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          this.deletePushChannelAsync(data.row.id)
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消"
          // });
        });
    },

    //查看渠道配置
    openPzClick (data) { },










    //获取推送渠道模板
    async getChannelTemplateAsync () {
      let { status, data, message, errors } = await getPowerTemplate();
      if (status) {
        this.template = data
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },





    //获取推送渠道模板
    async getPowerTemplateAsync () {
      let { status, data, message, errors } = await getPowerTemplate();
      if (status) {
        // console.log(this.myform.template)
        if (this.myform.template === 'routersoft-qms') {
          this.demo = data[0].demo
        } else if (this.myform.template === 'routersoft-mcp') {
          this.demo = data[1].demo
        }else if(this.myform.template === 'eastnet-mc'){
          this.demo = data[2].demo
        }
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },






    //获取用户列表
    async listPushChannelAsync (val) {
      this.isRefresh = true
      let { status, data, message, pagination, errors } = await listPushChannel(val);
      if (status) {
        this.pushChannelList = data;
        this.total = pagination.total
        for (let i = 0; i < this.pushChannelList.length; i++) {
          this.pushChannelList[i].createAtMY = formatConversion(this.pushChannelList[i].createAt.toString())
        }
        this.isRefresh = false
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false
      }
    },

    //查询用户
    async getPushChannelAsync (val, flag) {
      let { status, data, message, errors } = await getPushChannel(val);
      if (status) {
        if (flag === 0) {
          this.mydialogVisible = true;
          this.myform = { ...data }
        } else {
          if (data.status === 0) {
            data.status = 1
          } else {
            data.status = 0
          }
          this.updatePushChannelAsync(data)
        }
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //删除用户
    async deletePushChannelAsync (val) {
      let { status, data, message, errors } = await deletePushChannel(val);
      if (status) {
        this.$message.success("删除成功！");
        this.handleCurrentChange(this.currentPage);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //修改用户信息
    async updatePushChannelAsync (val) {
      let { status, data, message, errors } = await updatePushChannel(val);
      if (status) {
        this.mydialogVisible = false
        this.$message.success("修改成功！");
        this.handleCurrentChange(this.currentPage);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //增加用户

    async addPushChannelAsync (val) {
      let { status, data, message, errors } = await addPushChannel(val);
      if (status) {
        this.mydialogVisible = false
        this.$message.success("添加成功！");
        this.handleCurrentChange(1);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    }
  },
  created () {
    this.getChannelTemplateAsync()
    this.handleCurrentChange(this.currentPage);
    this.timeInt = setInterval(() => {
      this.handleCurrentChange(this.currentPage);
    }, 90000);
  },
  beforeDestroy () {  // 组件销毁前调用
    clearTimeout(this.timeInt)
  },
  mounted () { }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./pushchannelmanage.scss";
@import "@/constants/elHeader.scss";
h4 {
  font-size: 18px;
}
.labelclass {
  position: relative;
  p {
    font-size: 13px;
    position: absolute;
    bottom: -24px;
    right: 10px;
  }
}
.el-form ::v-deep .el-select {
  width: 100%;
}
::v-deep .el-form-item__label {
  font-weight: 600;
}
</style>
